module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa5_m.0967fbea0f5ffbf527ca7e7153ae6607.png";